import { SEARCH_RESULTS, SEARCH_RESET, SEARCH_INPUT, UPDATE_SEARCHED_ITEMS } from './search.constants';

export const initialState = {
  debounceId: undefined,
  searchInput: '',
  searchHistory: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_RESULTS:
      return {
        ...state,
        searchInput: action.query || state.searchInput,
      };
    case SEARCH_INPUT:
      return {
        ...state,
        searchInput: action.query,
        debounceId: action.debounceId,
      };
    case UPDATE_SEARCHED_ITEMS:
      return {
        ...state,
        searchHistory: action.searchedItems,
      };
    case SEARCH_RESET:
      return initialState;
    default:
      return state;
  }
};
